import { render, staticRenderFns } from "./topCharts.vue?vue&type=template&id=5d573db6&"
import script from "./topCharts.vue?vue&type=script&lang=js&"
export * from "./topCharts.vue?vue&type=script&lang=js&"
import style0 from "./topCharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports